//Adapted from https://snipcart.com/blog/vue-js-plugin
import Vue from 'vue'
import i18n from 'RuterShared/i18n'
import router from 'RuterTheme/router'
import store from 'RuterTheme/store'
Vue.use(i18n)

import OverlayContainer from '../components/global/overlay/Container'

const optionsDefaults = {
	data: {
		targets: {},
		lang: i18n.locale
	}
}

export default {
	install(vue, opts){
		
		const options = { ...optionsDefaults, ...opts }
		const root = new Vue({
			i18n,
			router,
			store,
			data: { targets: options.data.targets },
			render: createElement => createElement(OverlayContainer)
		})
		
		root.$mount(document.body.appendChild(document.createElement('div')))

		vue.prototype.$globalOverlay = root

		vue.directive('global-overlay', {
			unbind(el, binding) {

				const data = {
					model: binding.value.model,
					requestPath: binding.value.requestPath,
					dark: binding.value.dark,
					index: binding.value.index,
					lang: options.data.lang,
					key: binding.value.index,
					getRect: () => el.getBoundingClientRect(),
				}

				el.removeEventListener('click', (e) => {
					e.preventDefault();
					e.target.classList.add('active-overlay-trigger-link')
					//root.$emit(`overlayTargetClicked__${binding.value.index}`, data)
					root.$emit(`overlayTargetClicked__${binding.value.index}`, data)
				});

				root.$delete(root.targets, binding.value.index);

			},
			bind(el, binding) {

				const data = {
					model: binding.value.model,
					requestPath: binding.value.requestPath,
					dark: binding.value.dark,
					index: binding.value.index,
					lang: options.data.lang,
					key: binding.value.index,
					getRect: () => el.getBoundingClientRect(),
				}

				root.$set(
					root.targets,
					binding.value.index, //binding.value.index,
					data
				);

				el.addEventListener('click', (e) => {
					e.preventDefault();
					e.target.classList.add('active-overlay-trigger-link')
					//root.$emit(`overlayTargetClicked__${binding.value.index}`, data)
					root.$emit(`overlayTargetClicked__${binding.value.index}`, data)
				});

			}
		})
	}
}